export const GET_APPLICATIONS = 'providers/AccessManagementApplication/GET_APPLICATION';
export const CREATE_APPLICATION = 'providers/AccessManagementApplication/CREATE_APPLICATION';
export const EDIT_APPLICATION = 'providers/AccessManagementApplication/EDIT_APPLICATION';
export const DELETE_APPLICATION = 'providers/AccessManagementApplication/DELETE_APPLICATION';
export const SELECTED_APPLICATION = 'providers/AccessManagementApplication/SELECTED_APPLICATION';
